import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import {
  getConfigurableToolsForPlacement,
  isToolEnabledForPlacement,
  setToolEnabledForPlacement,
} from '../viewerToolLayoutPreferences';

const CATEGORY_LABELS = Object.freeze({
  other: 'NAVIGATION',
  navigation: 'NAVIGATION',
  windowing: 'DISPLAY',
  measure: 'MEASUREMENTS',
  ROI: 'ROI / QUANTIFICATION',
  annotation: 'ANNOTATIONS',
  workflow: 'NAVIGATION / VIEWPORT',
});

export default function ToolPlacementPicker({ title, helperText = '', placement, layout, onChange }) {
  const tools = getConfigurableToolsForPlacement(placement);
  const groups = tools.reduce((result, tool) => {
    const category = tool.category || 'other';
    if (!result[category]) result[category] = [];
    result[category].push(tool);
    return result;
  }, {});

  return (
    <Box data-tool-placement-picker={placement} sx={{ display: 'grid', gap: 0.8 }}>
      <Box>
        <Typography sx={{ color: '#bfeff7', fontSize: 12, fontWeight: 800 }}>{title}</Typography>
        {helperText ? <Typography sx={{ color: '#78939e', fontSize: 10.5 }}>{helperText}</Typography> : null}
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 0.75 }}>
        {Object.entries(groups).map(([category, categoryTools]) => (
          <Box key={category} sx={{ border: '1px solid rgba(110,239,255,0.14)', borderRadius: 1.6, p: 0.8, bgcolor: 'rgba(3,12,18,0.56)', boxShadow: 'inset 0 1px rgba(255,255,255,0.02)' }}>
            <Typography sx={{ color: '#6eefff', fontSize: 9.5, fontFamily: 'monospace', fontWeight: 900, letterSpacing: 0.9, mb: 0.35 }}>
              {CATEGORY_LABELS[category] || 'OTHER'}
            </Typography>
            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(145px, 1fr))', gap: 0.45 }}>
              {categoryTools.map(tool => (
                <FormControlLabel
                  key={tool.id}
                  control={(
                    <Checkbox
                      size="small"
                      checked={isToolEnabledForPlacement(layout, placement, tool.id)}
                      onChange={event => onChange(setToolEnabledForPlacement(layout, placement, tool.id, event.target.checked))}
                    />
                  )}
                  label={tool.label}
                  sx={{
                    m: 0, px: 0.55, py: 0.35, minHeight: 34, borderRadius: 1.2,
                    border: isToolEnabledForPlacement(layout, placement, tool.id) ? '1px solid rgba(110,239,255,0.42)' : '1px solid rgba(110,239,255,0.08)',
                    bgcolor: isToolEnabledForPlacement(layout, placement, tool.id) ? 'rgba(0,188,212,0.10)' : 'rgba(0,0,0,0.10)',
                    transition: 'border-color 120ms ease, background-color 120ms ease',
                    '&:hover': { borderColor: 'rgba(110,239,255,0.38)', bgcolor: 'rgba(110,239,255,0.07)' },
                    '& .MuiCheckbox-root': { p: 0.45 },
                    '& .MuiFormControlLabel-label': { fontSize: 11.5, color: '#d7fbff' },
                  }}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
